var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturedThree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3023_100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 11C3 5.75329 7.25329 1.5 12.5 1.5H40.5C45.7467 1.5 50 5.75329 50 11V39C50 44.2467 45.7467 48.5 40.5 48.5H12.5C7.25329 48.5 3 44.2467 3 39V11Z",
    stroke: "#2563EB",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.5 25C16.5 20.286 16.5 17.9289 17.9645 16.4645C19.4289 15 21.786 15 26.5 15C31.214 15 33.5711 15 35.0355 16.4645C36.5 17.9289 36.5 20.286 36.5 25C36.5 29.714 36.5 32.0711 35.0355 33.5355C33.5711 35 31.214 35 26.5 35C21.786 35 19.4289 35 17.9645 33.5355C16.5 32.0711 16.5 29.714 16.5 25Z",
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 18C36.5 19.6569 35.1569 21 33.5 21C31.8431 21 30.5 19.6569 30.5 18C30.5 16.3431 31.8431 15 33.5 15C35.1569 15 36.5 16.3431 36.5 18Z",
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 23.75C28.5858 23.75 28.25 23.4142 28.25 23C28.25 22.5858 28.5858 22.25 29 22.25H31.5C31.9142 22.25 32.25 22.5858 32.25 23V25.5C32.25 25.9142 31.9142 26.25 31.5 26.25C31.0858 26.25 30.75 25.9142 30.75 25.5V24.8107L28.7374 26.8232C28.054 27.5066 26.946 27.5066 26.2626 26.8232L24.6768 25.2374C24.5791 25.1398 24.4209 25.1398 24.3232 25.2374L22.0303 27.5303C21.7374 27.8232 21.2626 27.8232 20.9697 27.5303C20.6768 27.2374 20.6768 26.7626 20.9697 26.4697L23.2626 24.1768C23.946 23.4934 25.054 23.4934 25.7374 24.1768L27.3232 25.7626C27.4209 25.8602 27.5791 25.8602 27.6768 25.7626L29.6893 23.75H29Z",
    fill: "#2563EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3023_100000",
    x: 0.5,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3023_100000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3023_100000",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedThree);
export default __webpack_public_path__ + "static/media/Featured_three.f033b782b5f90ef805745401de87bf07.svg";
export { ForwardRef as ReactComponent };